// extracted by mini-css-extract-plugin
module.exports = {"bundles":"GS_bundles__vWntE"};